import React from "react";
import UserImage from "./UserImage";

const ImagesList = ({
  userArt,
  imageType,
  layerId,
  selectedImageType,
  selectedId,
  handleChooseArt,
  onDelete,
  idToDelete,
}) => {
  return (
    <div className={`user-art__images`}>
      {userArt
        .filter((art) => art.field_type === imageType)
        .map((art) => {
          const imageUrl = `${process.env.REACT_APP_TEXT_EFFECTS_URL}userart/${art.id}?type=${imageType}`;

          return (
            <UserImage
              key={art.id}
              userart={art}
              imageType={imageType}
              layerId={layerId}
              imageUrl={imageUrl}
              selectedImageType={selectedImageType}
              selectedId={selectedId}
              handleChooseArt={handleChooseArt}
              onDelete={onDelete}
              idToDelete={idToDelete}
            />
          );
        })}
    </div>
  );
};

export default ImagesList;
